<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'm/task-process/attach/favorites' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">{{ 'm/close' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-button
    *ngIf="taskProcessContext"
    expand="block"
    (click)="selectLanguage($event)"
    class="lang-selector"
    [class.mobile]="!bundledWithAngularJSApp">
    <span class="content">
      <span class="placeholder">
        {{ languageTranslation }} : <span class="lang">{{ selectedLanguage?.name || 'Toutes' }}</span>
      </span>
      <ion-icon
        *ngIf="selectedLanguage"
        name="close-circle"
        (click)="clearLang($event)"
        class="clear"
        id="hover-trigger"
        [matTooltip]="'m/task-process/favorites/clear-lang' | translate"
        matTooltipClass="clear-lang">
      </ion-icon>
    </span>
    <ion-icon name="chevron-down"></ion-icon>
  </ion-button>

  <ion-searchbar
    *ngIf="favorites && favorites.length > 0"
    (ionChange)="onSearchInputChange($event)"
    debounce="500"
    placeholder="{{ 'm/task-process/favorites/search' | translate }}"></ion-searchbar>
</ion-header>

<ion-content>
  <ng-container *ngFor="let favorite of paginatedFilteredFavorites; trackBy: favoriteTrackBy">
    <ion-item data-testid="favorite" (click)="onFavClick(favorite)" button detail="false" lines="full">
      <ion-label class="ion-text-wrap">
        <ion-text color="primary">
          <h2>{{ favorite.title }}</h2>
        </ion-text>
        <p>{{ favorite.editorModel?.text || '' }}</p>
        <div class="attachments-container">
          <ng-container *ngFor="let attachment of favorite.editorModel.attachments">
            <ion-thumbnail *ngIf="attachment.type === 'picture'" slot="start">
              <img [appJwtSrc]="pictureURL + favorite.editorModel.pictures[0]" />
            </ion-thumbnail>
            <ng-container *ngIf="attachment.type === 'video'">
              <div
                *ngIf="!favorite.videoPlaceholderClicked"
                (click)="favorite.videoPlaceholderClicked = true; $event.stopPropagation()"
                class="video-placeholder">
                <ion-icon name="play-circle"></ion-icon>
              </div>
              <video
                *ngIf="favorite.videoPlaceholderClicked"
                (click)="$event.stopPropagation()"
                autoplay
                muted
                controls>
                <source [appJwtSrc]="videoURL + attachment.value.videoId" />
              </video>
            </ng-container>
            <div
              *ngIf="attachment.type === 'bzcRichLink'"
              layout="column"
              class="bzcRichLink-type-thumbnail"
              title="{{ attachment.value.title }}">
              <ion-thumbnail *ngIf="attachment.value.pictureId">
                <img [appJwtSrc]="pictureURL + attachment.value.pictureId" />
              </ion-thumbnail>
              <video
                *ngIf="attachment.value.videoId"
                [appJwtSrc]="videoURL + attachment.value.videoId"
                class="video-type-thumbnail"
                preload="auto"
                muted="true"
                controls></video>
              <div class="bzcRichLink-title">{{ attachment.value.title }}</div>
              <a [href]="attachment.value.url" target="_blank" class="bzcRichLink-url">{{ attachment.value.url }}</a>
            </div>
          </ng-container>
        </div>
      </ion-label>
    </ion-item>
  </ng-container>
  <ion-infinite-scroll threshold="100px" (ionInfinite)="loadMoreFavorites($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <div *ngIf="filteredFavorites && filteredFavorites.length === 0" class="no-favorites-msg">
    {{ 'm/task-process/favorites/no-favorites-available' | translate }}
  </div>
</ion-content>
